import {
  Directive,
  HostListener,
  ElementRef,
  Input,
  Optional,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMaxlengthEnforcer]',
  standalone: true,
})
export class MaxlengthEnforcerDirective {
  @Input('appMaxlengthEnforcer') maxLength: string | number;

  constructor(
    private readonly el: ElementRef,
    @Optional() private readonly ngControl: NgControl
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let limit: number;

    if (this.maxLength === 0) {
      limit = 0;
    } else if (this.maxLength) {
      limit = Number(this.maxLength);
    } else {
      limit = inputElement.maxLength;
    }

    if (limit > -1 && inputElement.value && inputElement.value.length > limit) {
      const truncatedValue = inputElement.value.slice(0, limit);

      if (this.ngControl?.control) {
        this.ngControl.control.setValue(truncatedValue);
      } else {
        inputElement.value = truncatedValue;
      }
    }
  }
}
